import { apiClient } from "@/services/apiClient";

/**
 * One row in the bell-icon inbox. Mirrors the backend
 * NotificationItemResponse — `deepLink.route` is an expo-router-style
 * template (e.g. `/invoices/[id]`) which the portal needs to translate
 * to its own React Router path (see `resolveInboxDeepLink` in the
 * inbox popover).
 */
export interface InboxItem {
  id: string;
  category: string;
  title: string;
  body: string;
  deepLink: { route: string; params?: Record<string, string> } | null;
  createdAt: string;
  readAt: string | null;
}

export interface InboxResponse {
  items: InboxItem[];
  unreadCount: number;
  hasMore: boolean;
}

export function listInbox(args: {
  limit?: number;
  before?: string;
} = {}): Promise<InboxResponse> {
  const params: Record<string, string> = {};
  if (args.limit != null) params.limit = String(args.limit);
  if (args.before) params.before = args.before;
  return apiClient
    .get<InboxResponse>("/notifications", { params })
    .then((res) => res.data);
}

export function getUnreadCount(): Promise<number> {
  return apiClient
    .get<{ unreadCount: number }>("/notifications/unread-count")
    .then((res) => res.data.unreadCount);
}

export function markRead(id: string): Promise<InboxItem> {
  return apiClient
    .patch<InboxItem>(`/notifications/${id}/read`)
    .then((res) => res.data);
}

export function markAllRead(): Promise<{ updated: number }> {
  return apiClient
    .post<{ updated: number }>("/notifications/read-all", {})
    .then((res) => res.data);
}

export function dismissNotification(id: string): Promise<void> {
  return apiClient.delete(`/notifications/${id}`).then(() => undefined);
}
